import styled, { createGlobalStyle } from "styled-components";
import AeonicAir from "../fonts/Aeonik-Air.otf";
import AeonikAirItalic from "../fonts/Aeonik-AirItalic.otf";
import AeonikBlack from "../fonts/Aeonik-Black.otf";
import AeonikBlackItalic from "../fonts/Aeonik-BlackItalic.otf";
import AeonikBold from "../fonts/Aeonik-Bold.otf";
import AeonikBoldItalic from "../fonts/Aeonik-BoldItalic.otf";
import AeonikLight from "../fonts/Aeonik-Light.otf";
import AeonikLightItalic from "../fonts/Aeonik-LightItalic.otf";
import AeonikMedium from "../fonts/Aeonik-Medium.otf";
import AeonikMediumItalic from "../fonts/Aeonik-MediumItalic.otf";
import AeonikRegular from "../fonts/Aeonik-Regular.otf";
import AeonikRegularItalic from "../fonts/Aeonik-RegularItalic.otf";
import AeonikThin from "../fonts/Aeonik-Thin.otf";
import AeonikThinItalic from "../fonts/Aeonik-ThinItalic.otf";

const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: "Aeonik - Black Italic";
  src: url(${AeonikBlackItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Black";
  src: url(${AeonikBlack});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Regular Italic";
  src: url(${AeonikBoldItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Regular";
  src: url(${AeonikBold});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Light Italic";
  src: url(${AeonikLightItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Light";
  src: url(${AeonikLight});
  font-weight: 100;
}


@font-face {
  font-family: "Aeonik - Thin Italic"; 
  src: url(${AeonikRegularItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Thin";
  src: url(${AeonikRegular});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Thin Italic";
  src: url(${AeonikThinItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Thin";
  src: url(${AeonikThin});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Air Italic";
  src: url(${AeonikAirItalic});
  font-weight: 100;
}

@font-face {
  font-family: "Aeonik - Air";
  src: url(${AeonicAir});
  font-weight: 100;
}


  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
`;

export const MainInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1760px;
  padding: 0 34px;
  margin: 0 auto;

  @media screen and (max-width: 680px) {
    max-width: 100%;
    padding: 0px 16px;
  }
`;

export default GlobalStyle;
